<template>

	<div class="docs">

		<div class="row">
			<div class="col-8 transition-fadeinup">

				<h2>Structure</h2>
				<p>Show</p>
				<p>Filtered navigation options:<br> 'parent': id of structure_item, or 0 to show everything<br> 'levels': 0 shows
					everything; 1 shows the direct descendants only; +1 for each submenu level<br> 'showHidden': 1 overrules
					hide_from_menu parameter</p>
				<a data-btn-header="pages" data-routing-target="#main" href="pages/pages.php" class=""><i class="fa fa-arrow-alt-circle-right"></i>
					Edit structure items</a>

			</div>
			<div class="col-10 push-1  transition-fadeinup transition-delay-01">

				<h4>Snipet:</h4>
				<div class="code">
					<pre class="language-php"><code>&lt;?= TS::nav('structure') ?&gt;
	&lt;?= TS::nav('landingpages') ?&gt;

	&lt;?= TS::nav('structure', array('parent' =&gt; 0, 'levels' =&gt; 0, 'showHidden' =&gt; 0)) ?&gt;</code></pre>
				</div>

				<h4>Ouput:</h4>
				<div class="code">
					<pre class="language-html"><code>&lt;ul&gt;
		&lt;li&gt;
			&lt;a href="#"&gt;home&lt;/a&gt;
		&lt;/li&gt;
		&lt;li&gt;
			Current page
		&lt;/li&gt;
	&lt;/ul&gt;</code></pre>
				</div>

			</div>
		</div>

		<hr>

		<div class="row">
			<div class="col-8 transition-fadeinup">

				<h2>Links</h2>
				<h4>Uri</h4>
				<p>Get the fully qualified URL of an object

				<table>
					<tr>
						<th>
							Argument
						</th>
						<th>
							Default
						</th>
					</tr>
					<tr>
						<td>
							<strong>id</strong> (int)<br> <i>ID of desired adressable object</i>
						</td>
						<td>
							"current page"
						</td>
					</tr>
					<tr>
						<td>
							<strong>object name</strong> (string)<br> <i>Name of desired object</i>
						</td>
						<td>
							structure_item
						</td>
					</tr>
				</table>

				<h4>Url</h4>
				<p>You can also get the URL for an addressable object's records like this, for structure items, the second
					parameter may be omitted.</p>
				<h4>Link</h4>
				<p>You can generate a single anchor tag for an addressable object's records like this, for structure items, the
					second parameter may be omitted.</p>

			</div>
			<div class="col-10 push-1  transition-fadeinup transition-delay-01">

				<h4>Snipet:</h4>
				<div class="code">
					<pre class="language-php"><code>&lt;?= TS::uri() ?&gt;
	&lt;?= TS::uri(1) ?&gt;
	&lt;?= TS::uri(1, 'news') ?&gt;

	&lt;?= TS::url(10, 'news') ?&gt;

	&lt;?= TS::link(5, 'news') ?&gt;</code></pre>
				</div>

				<h4>Ouput:</h4>
				<div class="code">
					<pre class="language-html"><code>/my_page
	/my_page
	/my_page

	http://www.mysite.be/my_page

	&lt;a href="#" class="active">http://www.mysite.be/my_page&lt;/a></code></pre>
				</div>

			</div>
		</div>

		<hr>

		<div class="row">
			<div class="col-8 transition-fadeinup">

				<h2>Breadcrumbs</h2>
				<p>It's possible to get a trail of the parent-structure items as div.breadcrumbs > a with the following
					function</p>

			</div>
			<div class="col-10 push-1  transition-fadeinup transition-delay-01">

				<h4>Snipet:</h4>
				<div class="code">
					<pre class="language-php"><code>&lt;?= TS::breadcrumbs() ?></code></pre>
				</div>

				<h4>Ouput:</h4>
				<div class="code">
					<pre class="language-html"><code>&lt;ul>
		&lt;li>&lt;a href="#">home&lt;/a>&lt;/li>
		&lt;li>Current page&lt;/li>
	&lt;/ul></code></pre>
				</div>

			</div>
		</div>

	</div>

</template>

<script>

export default {
	name: 'snippets'
}

</script>
